"use client";

import { createContext, useContext } from "react";

import type { FeedbackEvent } from "./feedback-events";

/**
 *
 */
export interface PlayOptions {
  /** Skip this single call regardless of user prefs. */
  silent?: boolean;
}

/**
 *
 */
export interface FeedbackContextValue {
  /** Fire both sound and haptic for an event (respecting the user toggles). */
  play: (event: FeedbackEvent, opts?: PlayOptions) => void;
  /** Whether sound feedback is currently enabled. */
  sound: boolean;
  /** Whether haptic feedback is currently enabled. */
  haptic: boolean;
  setSound: (enabled: boolean) => void;
  setHaptic: (enabled: boolean) => void;
}

const NOOP: FeedbackContextValue = {
  play: () => {},
  sound: false,
  haptic: false,
  setSound: () => {},
  setHaptic: () => {},
};

export const FeedbackContext = createContext<FeedbackContextValue | null>(null);

/**
 * Access the interaction-feedback API. Returns a safe no-op implementation when
 * no `FeedbackProvider` is mounted, so callers never need to null-check.
 */
export function useFeedback(): FeedbackContextValue {
  return useContext(FeedbackContext) ?? NOOP;
}
